<!-- Desktop (≥768px) -->
<aside class="share-bar" aria-label="Compartir">
  @for (n of networks; track n.id) {
    <button
      type="button"
      class="share-bar__btn"
      [attr.aria-label]="'Compartir en ' + n.label"
      (click)="share(n)"
    >
      <i [ngClass]="n.icon"></i>
    </button>
  }
</aside>

<!-- Mobile (<768px): speed dial -->
<div class="share-fab" [class.is-open]="open()">
  <ul class="share-fab__list" id="share-fab-list">
    @for (n of networks; track n.id; let i = $index) {
      <li
        class="share-fab__item"
        [style.--d]="(networks.length - 1 - i) * 40 + 'ms'"
      >
        <button
          type="button"
          class="share-fab__btn"
          [attr.aria-label]="'Compartir en ' + n.label"
          (click)="share(n); close()"
        >
          <i [ngClass]="n.icon"></i>
        </button>
      </li>
    }
  </ul>

  <button
    type="button"
    class="share-fab__btn"
    aria-label="Compartir"
    aria-controls="share-fab-list"
    [attr.aria-expanded]="open()"
    (click)="toggle()"
  >
    <i [ngClass]="faShareNodes"></i>
  </button>

  @if (pdfUrl(); as url) {
    <a
      class="share-fab__btn share-fab__btn--pdf"
      [href]="url"
      target="_blank"
      rel="noopener"
      aria-label="Descargar PDF"
    >
      <i [ngClass]="faFilePdf"></i>
    </a>
  }
</div>
